var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nsw-menu',{attrs:{"isShowDesktopMenu":false}}),_vm._v(" "),_c('div',{staticClass:"content-wrapper general"},[_c('terms-content',{staticClass:"terms-scope"})],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f5962b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Terms.vue
// module id = iges
// module chunks = 2 3 4 5 6